<template>
  <div>
    <div class="step-check-overview-title">
      <b>{{ lang.SET200 }}</b>
    </div>
    <table class="table table-striped">
      <thead>
        <tr>
          <th class="text-center" style="width: 15%">{{ lang.SET201 }}</th>
          <th class="text-center" style="width: 65%">{{ lang.SET202 }}</th>
          <th class="text-center" style="width: 20%">{{ lang.SET203 }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="cartItem in shopperCart.CartItems"
          :key="cartItem.CartItemGuid"
        >
          <td style="width: 15%">{{ cartItem.SurveyInstanceId }}</td>
          <td style="width: 65%">{{ cartItem.SurveyTitle }}</td>
          <td style="width: 20%">
            {{ globals.getCurrencyString(cartItem.Total, "EUR") }}
          </td>
        </tr>
        <tr class="total-background">
          <td colspan="2" class="align-total-text format-total-text">
            {{ lang.SET204 }}
          </td>
          <td class="format-total-text">
            {{ globals.getCurrencyString(shopperCart.Total, "EUR") }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "CheckOverview",
  props: {
    data: { type: Object, default: () => {} },
  },
  data() {
    return {
      lang: {
        SET200: "Checks",
        SET201: "Check ID",
        SET202: "Project",
        SET203: "Payment",
        SET204: "Total",
      },
    };
  },
  mounted() {
    this.globals.getLanguageStrings(this);
  },
  computed: {
    shopperCart() {
      return this.data;
    },
  },
};
</script>

<style scoped>
.step-check-overview-title {
  margin-bottom: 15px;
  background: lightgray;
  padding: 5px;
}
.align-total-text {
  text-align: right;
}
.format-total-text {
  font-weight: bold;
}
.total-background {
  background-color: #d8d8d8 !important;
}
</style>



// WEBPACK FOOTER //
// CheckOverview.vue?56719086